var __webpack_exports__ = {};
/*!**********************************!*\
  !*** ./src/scripts/read-more.js ***!
  \**********************************/
class readMore extends HTMLElement {
  constructor() {
    super()
    this.truncated =  this.querySelector('.truncated');
    this.fullDescription =  this.querySelector('.full-description');
    this.truncatedButton = this.truncated.querySelector('a.read-more')
    this.fullDescriptionButton = this.fullDescription.querySelector('a.read-less')
    this.truncatedButton.addEventListener(
      'click',
      this.onTruncatedClick.bind(this)
    );
    this.fullDescriptionButton.addEventListener(
      'click',
      this.onFullDescription.bind(this)
    );
  }

  onTruncatedClick(event) {
    this.fullDescription.classList.remove('hidden')
    this.truncated.classList.add('hidden')
  }

  onFullDescription(event) {
    this.fullDescription.classList.add('hidden')
    this.truncated.classList.remove('hidden')
  }

}
customElements.define('read-more', readMore)

